module.exports = __webpack_public_path__ + "img/716.a4721382.png";